import React, { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const services = [
  { name: "Custom Cabinets & Pantries", img: "/gallery/pantry.webp" },
  { name: "Stone Fireplace Enclosures", img: "/gallery/fireplace_new.jpg" },
  { name: "Outdoor Kitchens", img: "/gallery/ok_marble.jpg" },
  { name: "Stone Walks & Patios", img: "/gallery/patio_flagstone.jpg" },
  { name: "Interior Design", img: "/gallery/kitchen_interior.jpg" },
  { name: "Premium Painting — Interior & Exterior", img: "/gallery/exterior.webp" },
  { name: "Venetian Plaster", img: "/gallery/greatroom.jpg" },
  { name: "Elaborate Molding", img: "/gallery/security5.jpg" },
  { name: "Custom LED Lighting", img: "/gallery/fireplace_gray.jpg" },
  { name: "Pergolas", img: "/gallery/pergola.jpg" },
  { name: "Security Safe Rooms", img: "/gallery/security2.jpg" },
  { name: "Bullet-Resistant Construction", img: "/gallery/security3.jpg" },
  { name: "Hidden Rooms", img: "/gallery/security4.jpg" },
  { name: "Murphy Doors", img: "/gallery/security1.jpg" },
];

export default function ServicesGrid() {
  const [hover, setHover] = useState(null);
  const pos = useRef({ x: 0, y: 0 });
  const preview = useRef(null);

  const onMove = (e) => {
    pos.current = { x: e.clientX, y: e.clientY };
    if (preview.current) preview.current.style.transform = `translate(${e.clientX + 24}px, ${e.clientY - 120}px)`;
  };

  return (
    <section id="services" className="relative py-24 lg:py-40 border-t border-white/5" data-testid="services-section" onMouseMove={onMove}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="mb-14">
          <div className="overline mb-3">What We Craft</div>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-white leading-tight max-w-3xl">
            We can create <span className="gold-fill italic">almost anything</span> you want.
          </h2>
        </div>

        <ul className="divide-y divide-white/8" data-testid="services-list">
          {services.map((s, i) => (
            <li
              key={s.name}
              data-cursor="View"
              data-testid={`service-${i}`}
              onMouseEnter={() => setHover(i)}
              onMouseLeave={() => setHover(null)}
              className="group flex items-center justify-between py-5 lg:py-6 cursor-none"
            >
              <div className="flex items-baseline gap-5">
                <span className="overline w-10">{String(i + 1).padStart(2, "0")}</span>
                <span className={`font-display text-2xl sm:text-3xl lg:text-4xl transition-all duration-300 ${hover === i ? "gold-fill translate-x-2" : "text-white/75"}`}>
                  {s.name}
                </span>
              </div>
              <span className={`hidden sm:block h-px transition-all duration-500 ${hover === i ? "w-24 bg-[var(--gold)]" : "w-10 bg-white/20"}`} />
            </li>
          ))}
        </ul>
      </div>

      {/* cursor-following image preview */}
      <div ref={preview} className="fixed top-0 left-0 z-[60] pointer-events-none hidden md:block">
        <AnimatePresence>
          {hover !== null && (
            <motion.div
              key={hover}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
              className="w-64 h-44 rounded-lg overflow-hidden border border-[var(--gold)]/40 shadow-[0_0_40px_rgba(197,160,89,0.2)]"
            >
              <img src={services[hover].img} alt="" className="w-full h-full object-cover" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}
